import { Formik } from 'formik';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { backend } from '../axios/backend';
import { useAppContext } from '../context/AppContext';
import { parseErrorMessage } from '../utils/error-message';
import InputFormik from './formik/InputFormik';
import Button from './ui/Button';
import Modal from './ui/Modal';

export const AddPersonSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, 'Geht das auch länger? 😉')
    .max(40, 'Geht das auch kürzer? 😉')
    .required('Bitte gib einen Namen an.'),
  dateOfBirth: Yup.string().matches(
    /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/,
    'Bitte benutze folgendes Format: 01.01.2022',
  ),
});

type AddPersonModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

const AddPersonModal = (props: AddPersonModalProps) => {
  const { alertSuccess, alertError } = useAppContext();
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (values: { name: string }) => (await backend.post<string>('person', values)).data,
    {
      onSuccess: (personId) => {
        queryClient.invalidateQueries('persons');
        props.setIsOpen(false);
        alertSuccess('Person hinzugefügt.');
        navigate(`/ideas/${personId}`);
      },
      onError: (e) => {
        alertError(parseErrorMessage(e));
      },
    },
  );

  return (
    <Modal isOpen={props.isOpen} onDismiss={() => props.setIsOpen(false)} title="Neue Person">
      <Formik
        initialValues={{ name: '' }}
        onSubmit={(values) => {
          mutation.mutate({
            name: values.name,
          });
        }}
        validationSchema={AddPersonSchema}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <InputFormik name="name" label="Name" isRequired autoFocus />
              <Button type="submit" isLoading={mutation.isLoading}>
                Person hinzufügen
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddPersonModal;
